import routerApp from "../app.module";
import { getCacheBustedTemplate } from "../app.route";
import { EngineMode } from "../models/report";
import { roundToPlaces } from "../services/utilities";

routerApp.directive('meOperatingMode', () => {
  return {
    templateUrl: getCacheBustedTemplate('pages/directives/me-operating-mode.html'),
    link: (scope, _, attributes) => {
      const isEngineReport = attributes.source === 'engine';
      scope.context = isEngineReport ? scope.engine_report?.details : scope.report?.power;
      scope.meOpModeLabels = ["Fuel Type", "Engine Mode", "Operating Hours"];
      scope.$watch('report.power.main_engine_1_diff_rh', (newValue) => {
        scope.totalOpHrsMinMax =
          (isEngineReport || newValue == undefined) ? undefined : roundToPlaces(newValue, 2);
      });

      scope.shouldDisplayMeOpModeSection = (): boolean => {
        if(!scope.vesselSpecs?.information?.dual_fuel) return false;
        if(scope.isDieselElectricPropulsion()) return false;
        if(scope.vesselSpecs?.engine?.engine_modes?.length <= 0) return false;
        if(!isEngineReport && !scope.isOnlySeaReport(scope.report)) return false;
        return true;
      }
      const initializeEngineModes = () => {
        if (isEngineReport) {
          scope.context.me_operating_modes ??= [{}];
          return;
        }
        const carryOverModes: EngineMode[] = scope.carryOverReport?.power?.me_operating_modes;
        if (carryOverModes?.length) {
          scope.context.me_operating_modes ??= [carryOverModes[carryOverModes.length - 1]];
        }
        scope.context.me_operating_modes ??= [{}];
      };

      scope.$watch('carryOverDataLoaded', (loaded) => {
        if (loaded) initializeEngineModes();
      });

      scope.addEngineModeRow = () => {
        scope.context.me_operating_modes =
          [...scope.context.me_operating_modes, {}];
      };

      scope.removeEngineModeRow = (index: number) => {
        scope.context.me_operating_modes = 
          scope.context.me_operating_modes
            .filter((_, i) => 
              i !== index
            );
      };

      scope.shouldShowRemoveButton = (index: number): boolean =>
        (scope.context.me_operating_modes.length > 1 &&
        index === scope.context.me_operating_modes.length - 1);

      scope.isTotalEngineOpHrsValid = (): boolean =>{
        if(isEngineReport) return true;
        const meOpModeTotal =
          roundToPlaces(scope.report.power.me_operating_hours_total, 2);

        const meEngine1Diff =
          roundToPlaces(scope.report.power.main_engine_1_diff_rh, 2);
        return (meOpModeTotal === meEngine1Diff);
      }

      scope.$watch('context.me_operating_modes', (_) => {
        scope.context.me_operating_hours_total =
          roundToPlaces(
            (scope.context.me_operating_modes || [])
              .reduce((prev, curr) =>
                prev + (curr.operating_hours || 0),
                0
              ),
            2
          );
      }, true);
    }
  }
})